// context/WrapperContext.js
import { createContext, useContext } from 'react';

export const WrapperContext = createContext();

export const useWrapperContext = () => useContext(WrapperContext);
